import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@ui/Typography';
import palette from '@ui/palette';
import Icon from '@ui/Icon';

type ErrorMessageProps = {
  children: React.ReactNode;
  type: 'error' | 'warning';
  header?: string;
};

const IconBubble = ({ color }: { color: ErrorMessageProps['type'] }) => {
  return (
    <Box
      style={{
        backgroundColor:
          color === 'error' ? palette.punch_300 : palette.sunflower_300,
        borderRadius: 100,
        width: 16,
        height: 16,
      }}
      display="flex"
      alignItems="center"
      justifyContent="center"
      flexShrink={0}
    >
      <Icon
        type={'exclamation'}
        style={{ color: palette.gray_1000, strokeWidth: 4, fontSize: 12 }}
      />
    </Box>
  );
};

const ErrorMessage = ({ children, type, header }: ErrorMessageProps) => {
  if (!header) {
    return (
      <Box display="flex" alignItems="start" gap="8px">
        <IconBubble color={type} />
        <Typography variant="pSm">{children}</Typography>
      </Box>
    );
  }
  return (
    <Box display="flex" gap="8px">
      <IconBubble color={type} />
      <Box>
        <Box marginBottom={1}>
          <Typography variant="h5" bold>
            {header}
          </Typography>
        </Box>
        <Typography variant="pSm">{children}</Typography>
      </Box>
    </Box>
  );
};

export default ErrorMessage;
